import { getAPIURL } from "./config";

/**
 * Основной отчёт по Факту (ЭП)
 * GET /sketch_design/fact/calculate/{project_id}
 * @param {number} projectId - ID проекта (ЭП)
 * @returns {Promise<Array<{ work_type: Object, corrections: Object, twenty_percents: number }>>}
 */
export const getFactBasic = async (projectId) => {
  const response = await fetch(
    `${getAPIURL()}sketch_design/fact/calculate/${projectId}`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "include",
    }
  );
  if (!response.ok) {
    const errorText = await response.text();
    let message = `Ошибка загрузки факта: ${response.status} ${response.statusText}`;
    if (response.status === 422) {
      try {
        const err = JSON.parse(errorText);
        const details = Array.isArray(err.detail)
          ? err.detail.map((d) => d.msg || JSON.stringify(d)).join("; ")
          : err.detail;
        if (details) message = `Ошибка валидации: ${details}`;
      } catch {
        if (errorText) message += `. ${errorText}`;
      }
    } else if (errorText) {
      message += `. ${errorText}`;
    }
    throw new Error(message);
  }
  return response.json();
};

/**
 * Детальная информация по виду работы (Факт)
 * GET /sketch_design/fact/work_type/get/{project_id}/{work_type_id}
 * @param {number} projectId - ID проекта
 * @param {number} workTypeId - ID вида работ
 * @returns {Promise<Object|string>}
 */
export const getFactWorkType = async (projectId, workTypeId) => {
  const response = await fetch(
    `${getAPIURL()}sketch_design/fact/work_type/get/${projectId}/${workTypeId}`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "include",
    }
  );
  if (!response.ok) {
    const errorText = await response.text();
    let message = `Ошибка загрузки детализации: ${response.status} ${response.statusText}`;
    if (response.status === 422) {
      try {
        const err = JSON.parse(errorText);
        const details = Array.isArray(err.detail)
          ? err.detail.map((d) => d.msg || JSON.stringify(d)).join("; ")
          : err.detail;
        if (details) message = `Ошибка валидации: ${details}`;
      } catch {
        if (errorText) message += `. ${errorText}`;
      }
    } else if (errorText) {
      message += `. ${errorText}`;
    }
    throw new Error(message);
  }
  const data = await response.json();
  return data;
};
